import { getElementsById } from "core-integration/src/store/elements/reducers";
import { useSelector } from "react-redux";
import { elementPhotoStyles } from "./elementPhoto.css";

interface ElementPhotoProps {
  alt: string;
  // Elementid is optional so we can get placeholder photos for future weeks in the top element carousel
  elementId?: number;
}

/**
 * ElementPhoto component displays a player's photo based on their ID.
 * Use elementId of 0 for a placeholder image.
 */

const ElementPhoto = ({ alt, elementId }: ElementPhotoProps) => {
  const elementsById = useSelector(getElementsById);
  const elementPhotoDir = `${
    import.meta.env.VITE_PULSE_STATIC_BASE
  }/photos/players/110x140`;
  const missingPhotoFilename = "placeholder";

  // If elementId is not provided or the element has a temporary code, use placeholder
  const elementPhotoFilename =
    !elementId || elementsById[elementId].has_temporary_code
      ? missingPhotoFilename
      : elementsById[elementId].code;

  return (
    <img
      className={elementPhotoStyles}
      src={`${elementPhotoDir}/${elementPhotoFilename}.png`}
      alt={alt}
      role={alt === "" ? "presentation" : undefined}
      onError={(e) => {
        const fallbackSrc = `${elementPhotoDir}/${missingPhotoFilename}.png`;
        // Guard against an infinite reload loop if the fallback itself fails to load.
        if (e.currentTarget.src !== fallbackSrc) {
          e.currentTarget.src = fallbackSrc;
        }
      }}
    />
  );
};

export default ElementPhoto;
